import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "calendar-big",
  "use": "calendar-big-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"calendar-big\">\n  <path fill-rule=\"evenodd\" d=\"M268,248h-4v-2.5a1.5,1.5,0,0,0-3,0V248H247v-2.5a1.5,1.5,0,0,0-3,0V248h-4a2,2,0,0,0-2,2v24a2,2,0,0,0,2,2h28a2,2,0,0,0,2-2V250A2,2,0,0,0,268,248Zm-1,25H241V257h26v16Zm0-19H241v-3h26v3Z\" transform=\"translate(-238 -244)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/calendar-big.svg
// module id = null
// module chunks = 